import { ButtonRoot } from '@/components/common/Button'
import { FloatingModal } from '@/components/common/Floating'
import { Icon } from '@/components/icons/Icon'
import { IconAdvanced } from '@/components/icons/IconAdvanced'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { GALLERY_SIZE_LABELS, GALLERY_VIEW_SLUGS_SECTIONED, isGalleryViewSizeable } from '@/defs/gallery'
import { useModalProps } from '@/hooks/useModalProps'
import { galleryActions } from '@/store/gallery'
import { useReduxDispatch } from '@/store/hooks'
import { cn } from '@/utils/commonUtil'
import { scrollToAnchor } from '@/utils/scrollUtil'

import { GalleryCardFilters } from '../../GalleryCardFilters/GalleryCardFilters'
import { useGalleryDisplay } from '../../GalleryDisplayProvider/GalleryDisplayProvider'
import { useGalleryGroups } from '../../GalleryGroupsProvider/GalleryGroupsProvider'
import { GalleryControlsGroupby } from '../GalleryControlsGroupby/GalleryControlsGroupby'
import { GalleryControlsJumpDropdown } from '../GalleryControlsJumpDropdown/GalleryControlsJumpDropdown'
import { GalleryControlsJumpHeader } from '../GalleryControlsJumpHeader/GalleryControlsJumpHeader'
import { GalleryControlsReset } from '../GalleryControlsReset/GalleryControlsReset'
import { GalleryControlsRole } from '../GalleryControlsRole/GalleryControlsRole'
import { GalleryControlsSearch } from '../GalleryControlsSearch/GalleryControlsSearch'
import { GalleryControlsSize } from '../GalleryControlsSize/GalleryControlsSize'
import { GalleryControlsSortby } from '../GalleryControlsSortby/GalleryControlsSortby'
import { GalleryControlsView } from '../GalleryControlsView/GalleryControlsView'

import styles from './GalleryControlsMobile.module.scss'

const GalleryControlsModal = () => (
  <div className={styles.modal}>
    <div className={styles.modalTop}>
      <h2 className={styles.heading}>
        <IconWithLabel iconBefore='arrowDownArrowUp' iconBeforeSize='sm'>
          View Options
        </IconWithLabel>
      </h2>
      <div className={styles.actions}>
        <GalleryControlsReset />
      </div>
    </div>
    <GalleryControlsSearch />
    <GalleryControlsRole variant='horizontal' />
    <GalleryControlsSize variant='horizontal' />
    <GalleryControlsView variant='horizontal' />
    <GalleryControlsGroupby variant='horizontal' />
    <GalleryControlsSortby variant='horizontal' />
    <GalleryCardFilters />
  </div>
)

export const GalleryControlsMobile = () => {
  const dispatch = useReduxDispatch()
  const { size } = useGalleryDisplay()
  const { groups } = useGalleryGroups()
  const { editedCount, view } = useGalleryDisplay()
  const modalProps = useModalProps()

  const jumpGroups = GALLERY_VIEW_SLUGS_SECTIONED.includes(view) ? groups : []
  const showHeader = jumpGroups.length > 1

  const onClickSize = () => {
    const sizeNew = size === 'lg' ? 'sm' : 'lg'
    requestAnimationFrame(() => scrollToAnchor({ id: 'gallery', ifNearTop: true, isSmooth: true }))
    dispatch(galleryActions.setSize(sizeNew))
  }

  return (
    <>
      <div className={cn(styles.container, { showHeader, styles })}>
        <div className={styles.inner}>
          {showHeader && (
            <>
              <GalleryControlsJumpHeader groups={jumpGroups} />
              <GalleryControlsJumpDropdown groups={jumpGroups} />
            </>
          )}
          <div className={styles.buttons}>
            {isGalleryViewSizeable(view) && (
              <ButtonRoot aria-label='Toggle Size' className={styles.button} onClick={onClickSize}>
                <Icon name={size === 'lg' ? GALLERY_SIZE_LABELS.lg.icon : GALLERY_SIZE_LABELS.sm.icon} />
              </ButtonRoot>
            )}
            <ButtonRoot
              aria-label='Toggle Settings'
              className={styles.button}
              onClick={() => modalProps.setIsOpen(true)}
            >
              <IconAdvanced.Root count={editedCount} variant='settings' />
            </ButtonRoot>
          </div>
        </div>
      </div>
      <FloatingModal {...modalProps} content={<GalleryControlsModal />} size='lg' />
    </>
  )
}
